import { Box, Modal, Switch, TextField, Button } from '@mui/material'
import React from 'react'
import Swal from 'sweetalert2'
import { saveOrUpdateDataById } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  width: '35%',
  borderRadius: '16px',
  textAlign: 'center',
  maxHeight: '90vh',
  overflow: 'auto',
}

const VacationTimeModal = ({ toggleVacationTimeModal, modalOpen }) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [checked, setChecked] = React.useState(false)
  const [vacationDates, setVacationDates] = React.useState({
    user_id: user?.id,
    start_date: '',
    end_date: '',
  })

  const handleChange = (event) => {
    setChecked(event.target.checked)
  }

  const handleDateChange = (e) => {
    setVacationDates((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (vacationDates.end_date !== '' && vacationDates.start_date !== '') {
      let body = { ...vacationDates }
      let result = await saveOrUpdateDataById('add-vacation', body)
      if (result?.success === true && result?.data) {
        toggleVacationTimeModal(false)
        Swal.fire({
          icon: 'success',
          title: 'Vacation time updated successfully!',
          confirmButtonColor: '#2597F6',
          timer: 3000,
        })
      }
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => toggleVacationTimeModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          {/* <Container> */}
          <div className="ongoing-availability-modal-wrapper">
            <h3 className="fs-24 mb-4">Manage Vacation Time</h3>
            <form onSubmit={handleSubmit}>
              <div>
                <div className="day-section mt-3 px-2 d-flex flex-wrap justify-content-between align-items-center">
                  <p className="m-0">VACATION MODE</p>
                  <div className="py-1">
                    <Switch
                      checked={checked}
                      size={'small'}
                      className="switch"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                {checked && (
                  <div>
                    <div className="set-time px-2 py-2">
                      <div className="d-flex justify-content-between flex-wrap align-items-center">
                        <p className="m-0">STARTS ON</p>
                        <TextField
                          id="date"
                          type="date"
                          formTarget="YYYY-MM-DD"
                          name="start_date"
                          required
                          onChange={handleDateChange}
                          value={vacationDates.start_date}
                          sx={{ width: 'auto !important' }}
                        />
                      </div>
                    </div>
                    <div className="set-time px-2 py-2">
                      <div className="d-flex justify-content-between flex-wrap align-items-center">
                        <p className="m-0">ENDS ON</p>
                        <TextField
                          id="date"
                          type="date"
                          name="end_date"
                          formTarget="YYYY-MM-DD"
                          required
                          value={vacationDates.end_date}
                          onChange={handleDateChange}
                          sx={{ width: 'auto !important' }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Button
                fullWidth
                id="btn-primary-no-shadow"
                type="submit"
                className="mt-3"
              >
                Save
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default VacationTimeModal
